import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, getOrganizationBySlug, getEvents } from 'wasp/client/operations';
import { DashboardLayout } from '../../../client/components/Sidebar';
import { DirectoryEntriesTable } from '../../../components/ui/directory-entries-table';
import { Calendar } from 'lucide-react';
import { REGULAR_EVENTS_LIST_FILTERS } from '../../events/eventFilters';

export default function OrgEventsPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: org, isLoading: orgLoading } = useQuery(getOrganizationBySlug, { slug: slug! }) as { data: any; isLoading: boolean };

  const { data: events = [], isLoading: eventsLoading } = useQuery(
    getEvents,
    { organizationId: org?.id, filters: REGULAR_EVENTS_LIST_FILTERS },
    { enabled: !!org?.id }
  ) as { data: any[]; isLoading: boolean };

  const entries = events.map((event: any) => ({
    id: event.id,
    title: event.title,
    description: event.description,
    category: event.eventType ?? null,
  }));

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h1 className="text-2xl font-bold text-gray-900">Events / Activities</h1>
      </div>

      {(orgLoading || eventsLoading) && (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        </div>
      )}

      {!orgLoading && !eventsLoading && events.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          <Calendar className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>No events for this organization yet.</p>
        </div>
      )}

      {!orgLoading && !eventsLoading && events.length > 0 && (
        <DirectoryEntriesTable entries={entries} />
      )}
    </DashboardLayout>
  );
}
